import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "token-tx-table" }
const _hoisted_2 = { class: "total flex-left-stright" }
const _hoisted_3 = { class: "adr" }
const _hoisted_4 = { class: "copy-btn" }
const _hoisted_5 = { class: "tx-count" }

import { ElMessage } from "element-plus";
import { filterHash, filterNum, formatTime } from "@/utils/filters";
import type { TokenTxRow } from "@/mixins/useTokenDetail";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenTxTable',
  props: {
    addr: {},
    token: {},
    trades: {},
    loading: { type: Boolean },
    pages: {}
  },
  emits: ["clear"],
  setup(__props: any) {





function onCopyOk(): void {
  ElMessage.success("复制成功");
}

function onCopyErr(): void {
  ElMessage.warning("复制失败");
}

function txTime(raw: string | number | undefined): string {
  if (raw == null || raw === "") return "-";
  const t =
    typeof raw === "number"
      ? raw
      : /^\d+$/.test(String(raw))
      ? Number(raw)
      : new Date(String(raw)).getTime();
  if (Number.isNaN(t)) return "-";
  return String(formatTime(t));
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_clipboard = _resolveDirective("clipboard")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.addr && _ctx.addr.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tx-count" }, "按代币持有者筛选", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: `/address?address=${_ctx.addr}`,
                class: "light"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(filterHash)(_ctx.addr, 20)), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, _cache[1] || (_cache[1] = [
                _createTextVNode(" 复制 ")
              ]))), [
                [_directive_clipboard, _ctx.addr, "copy"],
                [_directive_clipboard, onCopyOk, "success"],
                [_directive_clipboard, onCopyErr, "error"]
              ]),
              _createElementVNode("i", {
                class: "iconfont iconshanchu clear-ico",
                title: "清除筛选",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear')))
              })
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, "共找到 " + _toDisplayString(_unref(filterNum)(_ctx.pages.total) || 0) + " 笔交易", 1)
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.trades,
      stripe: "",
      style: {"width":"100%"},
      class: "data-table",
      "empty-text": "暂无数据",
      "element-loading-text": "拼命加载中...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.8)"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "交易哈希",
          "min-width": "200"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/tradeHash?hash=${item.row.hash || item.row.tx_hash}`,
              class: "light flex-left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["iconfont err-ico", {
                'iconjinggao-chucuo':
                  item.row.success === false && item.row.is_para === false,
              }])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_unref(filterHash)(item.row.hash || item.row.tx_hash, 10)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "发送方",
          "min-width": "160"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/address?address=${item.row.from}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.from, 12)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "56",
          align: "center"
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "iconfont iconjiantou-you arrow-ico" }, null, -1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "接收方",
          "min-width": "160"
        }, {
          default: _withCtx((item) => [
            _createVNode(_component_router_link, {
              to: `/address?address=${item.row.to}`,
              class: "light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(filterHash)(item.row.to, 12)), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "数量",
          width: "140",
          align: "center"
        }, {
          default: _withCtx((item) => [
            _createTextVNode(_toDisplayString(item.row.value_formatted ?? item.row.value ?? "-") + " " + _toDisplayString(item.row.token_symbol || _ctx.token), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "时间",
          width: "180",
          align: "center"
        }, {
          default: _withCtx((item) => [
            _createElementVNode("span", null, _toDisplayString(txTime(item.row.block_time)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}
}

})